module.exports = __webpack_public_path__ + "img/groupIcon1.420a8890.jpg";